import type { ReportBundle, ReportDimension } from '../../../shared/types.js';
import { scopeLabel } from '../../lib/scope.js';

const CATEGORY_LABEL: Record<string, string> = {
  scope_accountability: 'Scope & accountability',
  behaviours_actions: 'Behaviours & actions',
};

function DimensionCard({ d }: { d: ReportDimension }) {
  if (!d.evidenced) {
    return (
      <div className="gap-card hole">
        <div className="gap-card-head">
          <span className="gap-dim">{d.name}</span>
          <span>
            <span className="badge level">Assigned {d.assigned.level}</span>{' '}
            <span className="badge no-evidence">No evidence</span>
          </span>
        </div>
        <p className="gap-desc">{d.assigned.descriptor}</p>
        <p className="gap-desc hole-note">Nothing logged in this period — a hole to fill before review.</p>
      </div>
    );
  }
  return (
    <div className="gap-card">
      <div className="gap-card-head">
        <span className="gap-dim">{d.name}</span>
        <span>
          <span className="badge level">Assigned {d.assigned.level}</span> →{' '}
          <span className="badge evidenced">Evidenced {d.evidenced.level}</span>{' '}
          <span className="badge delta">{(d.delta ?? 0) >= 0 ? '+' : ''}{d.delta}</span>
        </span>
      </div>
      <div className="gap-cols">
        <div>
          <span className="label">{d.assigned.level} · assigned</span>
          <p className="gap-desc">{d.assigned.descriptor}</p>
        </div>
        <div>
          <span className="label">{d.evidenced.level} · evidenced</span>
          <p className="gap-desc">{d.evidenced.descriptor}</p>
        </div>
      </div>
      <ul className="gap-entries">
        {d.entries.map((e) => (
          <li key={e.id}>
            {e.scope === 'stretch' && <span className="badge scope">{scopeLabel(e.scope)}</span>}{' '}
            {e.title} <span className="muted">— {e.demonstrated_level}</span>
            {e.rationale && <span className="muted"> · {e.rationale}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}

export function GapReport({ report }: { report: ReportBundle }) {
  const categories = [...new Set(report.dimensions.map((d) => d.category))];
  return (
    <div className="gap-report">
      {categories.map((cat) => (
        <section key={cat}>
          <h3>{CATEGORY_LABEL[cat] ?? cat}</h3>
          {report.dimensions
            .filter((d) => d.category === cat)
            .map((d) => (
              <DimensionCard key={d.id} d={d} />
            ))}
        </section>
      ))}
    </div>
  );
}
